import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import axios from 'axios'
import Cookie from 'js-cookie'
import toast from 'react-hot-toast'

export interface Res {
  status: 0 | 1
  data: any
  msg: string
  [key: string]: any
}

export interface TaiRes {
  code: 200 | number
  success: boolean
  [key: string]: any
}

const service: AxiosInstance = axios.create({
  baseURL: '',
  withCredentials: true,
  timeout: 12000
})

service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const { headers } = config
    if (headers && localStorage.token) {
      headers['Authorization'] = localStorage.token || Cookie.get('token')
    }
    return config
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

const ignoreApi: string[] = ['/pc_api/api/pc/inSpareRoom']

service.interceptors.response.use(
  (res) => {
    if (res.data.status === 1 && res.config.url && !ignoreApi.includes(res.config.url)) {
      toast.error(res.data.msg || '服务错误')
    }
    if (res.data.status === 403) {
      toast.error('登录超时，请重新登录！')
      localStorage.clear()
      window.location.replace('/')
    }
    if (res.headers['content-type'] === 'application/octet-stream') {
      return Promise.resolve(res)
    }
    return Promise.resolve(res.data)
  },
  (error) => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      toast.error('登录超时，请重新登录！')
      localStorage.clear()
      window.location.replace('/')
      return Promise.reject(error.message)
    }
    toast.error(error?.response?.data?.msg || error.message)
    return Promise.reject(error?.response?.data?.msg || error.message)
  }
)

export default service
